import isApiError from "@insite/client-framework/Common/isApiError";
import { replaceInChain } from "@insite/client-framework/HandlerCreator";
import {
    getAlsoPurchasedProductsCollectionV2,
    getProductCollectionV2,
    getRelatedProductsCollectionV2,
} from "@insite/client-framework/Services/ProductServiceV2";
import { StorefrontAccess } from "@insite/client-framework/Services/SettingsService";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import { getCurrentPage, getLocation } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import {
    chain,
    PopulateApiParameter,
    RequestDataFromApi,
} from "@insite/client-framework/Store/Data/Products/Handlers/LoadProducts";
import { getProductsDataView } from "@insite/client-framework/Store/Data/Products/ProductsSelectors";
import { getProductListDataViewProperty } from "@insite/client-framework/Store/Pages/ProductList/ProductListSelectors";

replaceInChain(chain, PopulateApiParameter, props => {
    const { onSuccess, onError, isLoadMore, ...parameter } = props.parameter;
    const state = props.getState();
    const location = getLocation(state);
    const searchParams = new URLSearchParams(location.search);
    props.apiParameter = parameter;

    // Verndale customization
    const listFacets = getProductListDataViewProperty(state, "properties")?.wishListFacets || "";
    const wishListIdStored = searchParams.get("wishlistIds");
    const categoryIds = searchParams.get("categoryIds") || ""

    const propertiesObject = {
        wishlistIds: wishListIdStored || "",
        listFacets: listFacets || "",
        categoryIds: categoryIds || "",
    };

    (props.apiParameter as any).properties = JSON.stringify(propertiesObject);

    if (props.parameter.isLoadMore) {
        const prevApiParams: typeof props.apiParameter = { ...props.apiParameter };
        prevApiParams.page =
            props.apiParameter.page && props.apiParameter.page > 1 ? props.apiParameter.page - 1 : undefined;
        const prevProducts = getProductsDataView(props.getState(), prevApiParams).value;
        if (!prevProducts && props.parameter.page && props.parameter.page > 1) {
            props.apiParameter.page = 1;
            props.apiParameter.pageSize = props.parameter.pageSize! * props.parameter.page;
        }
    }
});

replaceInChain(chain, RequestDataFromApi, async props => {
    const state = props.getState();
    const currentPage = getCurrentPage(state);
    const { storefrontAccess } = getSettingsCollection(state).productSettings;
    if (
        storefrontAccess === StorefrontAccess.SignInRequiredToBrowse &&
        !state.context.session.isAuthenticated &&
        (currentPage.fields.excludeFromSignInRequired || currentPage.type === "SignInPage")
    ) {
        return false;
    }

    try {
        if ("relationship" in props.apiParameter) {
            props.apiResult = await getRelatedProductsCollectionV2(props.apiParameter);
        } else if ("productId" in props.apiParameter && props.apiParameter?.type === "alsoPurchased") {
            props.apiResult = await getAlsoPurchasedProductsCollectionV2(props.apiParameter);
        } else {
            props.apiResult = await getProductCollectionV2(props.apiParameter);
        }
    } catch (error) {
        if (isApiError(error) && error.status === 400) {
            props.parameter.onError?.(error.errorJson.message);
            return false;
        }

        if (storefrontAccess === StorefrontAccess.SignInRequiredToBrowse && error.status === 403) {
            // auth timed out with SignInRequiredToBrowsee - throw this up as a 401 so DisplayError reloads the site
            error.status = 401;
            error.errorJson = { message: "error" };
        }

        throw error;
    }
});
